export function animationBlurred(daley){
  return({
    animation: `slide-in-blurred-bottom  0.3s ${daley}s cubic-bezier(0.230, 1.000, 0.320, 1.000) both`,
  })
}
export function animationScale(daley){
  return({
    animation: `scale-in-center 0.6s ${daley}s cubic-bezier(0.250, 0.460, 0.450, 0.940) both`
  })
}
export function jelloScale(daley){
  return({
    animation: `jello-vertical  0.9s ${daley}s cubic-bezier(0.250, 0.460, 0.450, 0.940) both`
  })
}

export const descriptionStyle = {
  animation: `scale-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both`,
  opacity: "1",
} 

export const descriptionStyleOff = {
  
  animation: `scale-out-center 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both`,
  opacity: "0",
  transform:" scale(0)",
} 